// Bug #3b — delete-or-archive for parallel-run test orders.
//
// The backend refuses to DELETE any order that carries payment-ledger rows
// (409, reason:'has_ledger') and says whether ARCHIVE is the alternative
// (can_archive, decided by lib/archiveRules on the server). The UI branches
// on that response — never on amount_paid, which is a display number and
// not the ledger. Archive/un-archive are owner-only routes.
import axios from './axiosClient';

export const ARCHIVE_ORDERS_URL = '/api/rentals/archive/orders';

const REAL_MONEY_CODES = ['real_money', 'not_test_order', 'interest_charges'];

const blockerText = (blockers) => (blockers || []).map(b => b.message).filter(Boolean).join(' ');

// POST the archive. Returns true on success; shows a toast either way.
export async function archiveOrder(order, { showFlash }) {
  try {
    await axios.post(ARCHIVE_ORDERS_URL, { order_ids: [order.id] });
    showFlash('Order archived');
    return true;
  } catch (e) {
    const d = e.response?.data || {};
    const why = d.failures?.[0] ? blockerText(d.failures[0].blockers) : '';
    showFlash(why || d.error || 'Archive failed', 'error');
    return false;
  }
}

// POST the un-archive. Returns true on success; shows a toast either way.
export async function unarchiveOrder(order, { showFlash }) {
  try {
    await axios.post(`${ARCHIVE_ORDERS_URL}/${order.id}/unarchive`);
    showFlash('Order restored');
    return true;
  } catch (e) {
    showFlash(e.response?.data?.error || 'Un-archive failed', 'error');
    return false;
  }
}

// Confirm, attempt the DELETE, and on the has_ledger 409 offer the archive
// when the server says the order qualifies. Returns 'deleted', 'archived',
// or null (nothing changed).
export async function deleteOrArchiveOrder(order, { showFlash, isOwner }) {
  if (!window.confirm('Delete this order?')) return null;
  try {
    await axios.delete(`/api/rentals/orders/${order.id}`);
    showFlash('Order deleted');
    return 'deleted';
  } catch (e) {
    const d = e.response?.data || {};
    if (e.response?.status !== 409 || d.reason !== 'has_ledger') {
      showFlash(d.error || 'Delete failed', 'error');
      return null;
    }
    if (d.already_archived) {
      showFlash('This order is already archived.', 'error');
      return null;
    }
    if (d.can_archive) {
      if (!isOwner) {
        window.alert("This test order has recorded test payments and can't be deleted. Ask the owner to archive it.");
        return null;
      }
      if (!window.confirm("This test order has recorded test payments and can't be deleted. Archive it instead?\n\nOK = Archive · Cancel = keep the order")) return null;
      return (await archiveOrder(order, { showFlash })) ? 'archived' : null;
    }
    const blockers = d.archive_blockers || [];
    const realMoney = !blockers.length || blockers.some(b => REAL_MONEY_CODES.includes(b.code));
    window.alert(realMoney
      ? "This order has real payments recorded and can't be deleted."
      : `This test order has recorded test payments and can't be deleted. ${blockerText(blockers)}`);
    return null;
  }
}
